// extracted by mini-css-extract-plugin
module.exports = {"generalToolbar":"GeneralToolbar_generalToolbar__1fhnS","help":"GeneralToolbar_help__33Gvm"};